import { render, staticRenderFns } from "./CardPropertyGeoPoint.vue?vue&type=template&id=4b270d4a&scoped=true&"
import script from "./CardPropertyGeoPoint.vue?vue&type=script&lang=js&"
export * from "./CardPropertyGeoPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b270d4a",
  null
  
)

export default component.exports
import {QInput,QBtn,QTooltip,QItem,QItemSection,QAvatar,QImg,QDialog,QCard,QCardSection,QIcon,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QInput,QBtn,QTooltip,QItem,QItemSection,QAvatar,QImg,QDialog,QCard,QCardSection,QIcon,QSeparator,QCardActions}, component.options.components || {})
